// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/etl/v1/etl.proto (package mono.etl.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { CancelJobRequest, CancelJobResponse, GetJobRequest, GetJobResponse, GetJobStatusRequest, GetJobStatusResponse, ListJobsRequest, ListJobsResponse, ProcessDocumentRequest, ProcessDocumentResponse, SubmitJobRequest, SubmitJobResponse } from "./etl_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * EtlService provides ETL pipeline and job orchestration operations.
 *
 * @generated from service mono.etl.v1.EtlService
 */ export const EtlService = {
    typeName: "mono.etl.v1.EtlService",
    methods: {
        /**
     * ProcessDocument submits a document for ETL processing.
     *
     * @generated from rpc mono.etl.v1.EtlService.ProcessDocument
     */ processDocument: {
            name: "ProcessDocument",
            I: ProcessDocumentRequest,
            O: ProcessDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * SubmitJob creates a new ETL job.
     *
     * @generated from rpc mono.etl.v1.EtlService.SubmitJob
     */ submitJob: {
            name: "SubmitJob",
            I: SubmitJobRequest,
            O: SubmitJobResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListJobs returns all jobs, optionally filtered.
     *
     * @generated from rpc mono.etl.v1.EtlService.ListJobs
     */ listJobs: {
            name: "ListJobs",
            I: ListJobsRequest,
            O: ListJobsResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetJob returns details for a specific job.
     *
     * @generated from rpc mono.etl.v1.EtlService.GetJob
     */ getJob: {
            name: "GetJob",
            I: GetJobRequest,
            O: GetJobResponse,
            kind: MethodKind.Unary
        },
        /**
     * CancelJob cancels a running job.
     *
     * @generated from rpc mono.etl.v1.EtlService.CancelJob
     */ cancelJob: {
            name: "CancelJob",
            I: CancelJobRequest,
            O: CancelJobResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetJobStatus returns the current status of a job.
     *
     * @generated from rpc mono.etl.v1.EtlService.GetJobStatus
     */ getJobStatus: {
            name: "GetJobStatus",
            I: GetJobStatusRequest,
            O: GetJobStatusResponse,
            kind: MethodKind.Unary
        }
    }
};
